function generate_guid() {
    var guid = null

    if (self?.crypto?.randomUUID) {
        guid = self.crypto.randomUUID();
    }
    else {
        guid = Math.random().toString(36).substring(2)
    }
    
    return guid
}

export { generate_guid }
